import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";

import { getBasicInformationRes } from "core/http/service/personnelInformation/resTypes";
import moment from "moment";
import { uniqueId } from "lodash";

interface InitialState {
  status: ReduxStateType;
  data: getBasicInformationRes;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  data: {
    fullName: "",
    bornAddress: "",
    bornDate: "",
    domicileAddress: "",
    email: "",
    gender: "",
    idIssueDate: null,
    idIssuePlaceCode: "",
    idIssuePlace: "",
    idNo: "",
    mobile: "",
    taxCode: "",
    files: [],
    files_files: [],
  },
};

const getBasicInformationSlice = createSlice({
  name: "getBasicInformation",
  initialState,
  reducers: {
    getBasicInformationStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getBasicInformationSuccess: (
      state,
      action: PayloadAction<getBasicInformationRes>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      const files = (action.payload.files ?? []).map((file) => ({
        ...file,
        id: uniqueId(),
      }));
      state.data = {
        ...action.payload,
        idIssueDate:
          moment(action.payload.idIssueDate).format("DD/MM/YYYY") || null,
        files: files,
      };
    },
    getBasicInformationFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetBasicInformation: () => {
      return { ...initialState };
    },
  },
});

export const {
  getBasicInformationStart,
  getBasicInformationSuccess,
  getBasicInformationFailed,
  resetBasicInformation,
} = getBasicInformationSlice.actions;

export default getBasicInformationSlice.reducer;
